/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_StartInputs */

const es_home_cta_start = /** @type {(inputs: Home_Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar Gratis`)
};

const en_home_cta_start = /** @type {(inputs: Home_Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Free`)
};

/**
* | output |
* | --- |
* | "Start Free" |
*
* @param {Home_Cta_StartInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_cta_start = /** @type {((inputs?: Home_Cta_StartInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_StartInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_cta_start(inputs)
	return en_home_cta_start(inputs)
});
export { home_cta_start as "home.cta.start" }